package me.repeater64.advancedmpkeditor.gui.screens

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Button
import androidx.compose.material3.ExperimentalMaterial3ExpressiveApi
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch
import me.repeater64.advancedmpkeditor.backend.data_object.saved_hotbar.SavedHotbars
import me.repeater64.advancedmpkeditor.gui.platform.FileDropZone
import me.repeater64.advancedmpkeditor.gui.platform.HotbarNbtFileManager

@OptIn(ExperimentalMaterial3ExpressiveApi::class)
@Composable
fun ImportScreen(
    fileManager: HotbarNbtFileManager,
    onHotbarsLoaded: (SavedHotbars) -> Unit
) {
    val scope = rememberCoroutineScope()
    var errorMessage by remember { mutableStateOf<String?>(null) }

    BasicFullyScrollableScreen(Modifier.width(1000.dp), Arrangement.spacedBy(16.dp)) {

        Text(
            "Import From \"hotbar.nbt\"",
            style = MaterialTheme.typography.displaySmallEmphasized,
            color = MaterialTheme.colorScheme.primary
        )

        Text(
            "Upload your hotbar.nbt file to continue editing",
            style = MaterialTheme.typography.headlineMedium,
            color = MaterialTheme.colorScheme.secondary,
            textAlign = TextAlign.Center
        )

        Text(
            "If you upload a hotbar.nbt file that you generated with this website, everything will be perfectly preserved and you can continue editing from where you left off. If you upload a hotbar.nbt file that wasn't generated by this website, it will also be imported fine, but note that when you download it again at the end, it will be converted to the format that Advanced MPK editor uses, which means it will no longer be manually editable and you will only be able to edit that hotbar.nbt again by uploading it back to this website. So you may wish to keep a backup of your original hotbar.nbt somewhere.",
            style = MaterialTheme.typography.titleSmall,
            color = MaterialTheme.colorScheme.secondary,
            textAlign = TextAlign.Center
        )

        Spacer(Modifier.height(16.dp))

        FileDropZone(
            modifier = Modifier
                .fillMaxWidth(0.8f)
                .height(200.dp)
                .background(Color(0xFF2C2C2C), MaterialTheme.shapes.medium), // Darker bg
            onFileDropped = { hotbars ->
                if (hotbars != null) {
                    onHotbarsLoaded(hotbars)
                } else {
                    errorMessage = "Failed to load file. Are you sure it is a 1.16.1 hotbar.nbt file?"
                }
            }
        ) {
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                Text("Drag & Drop hotbar.nbt here", color = Color.Gray, style = MaterialTheme.typography.titleLarge)
            }
        }

        Text("OR", style = MaterialTheme.typography.labelMedium)

        Button(onClick = {
            scope.launch {
                val loaded = fileManager.loadHotbars()
                if (loaded != null) {
                    onHotbarsLoaded(loaded)
                } else {
                    errorMessage = "Failed to load file. Are you sure it is a 1.16.1 hotbar.nbt file?"
                }
            }
        }) {
            Text("Select File...")
        }

        if (errorMessage != null) {
            Text(errorMessage!!, color = MaterialTheme.colorScheme.error)
        }
    }
}